import { BaseService } from '../base';
import { QuoteSchema } from './types';

export type { QuoteSchema } from './types';

export class QuotesSchemasService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  constructor() {
    super();
  }

  async getQuoteSchema(category: string): Promise<{
    success: boolean;
    data?: QuoteSchema;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/quotes/schemas?category=${category}`;
      const response = await this.get(path, {}, this.customBaseUrl);
      return this.handleJsonResponse<QuoteSchema>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar schema de cotação',
      };
    }
  }
}

export const quotesSchemasService = new QuotesSchemasService();
